// extracted by mini-css-extract-plugin
module.exports =  {"tc-intercom":"Intercom-module__tc-intercom___YinCf","open":"Intercom-module__open___O801v"};